//File contains the blockchain integration functions to interact with the blockchain functions
import presale from "../blockchain/Presale.json";
import {BrowserProvider, ethers, formatEther, parseEther} from 'ethers';

const BigNumber = require('bignumber.js');


//Function to Layer 1 registerAffiliate for affiliate page 
export const registerAffiliate = async (contract) => {
  try {
    console.log("RegisterAffiliate contract : ",contract)
    const register = await contract.registerFirstAffiliate();
    const result = {
      status:"success",
      message:register,
    }
    return result;
  } catch (error) {
    console.log("RegisterAffiliate Error: ",error);
    const result = {
      status:"error",
      message:error.reason ? error.reason:"Something went wrong",
    }
    return result;
  }
}

export const registerPresalePromoter = async (contract) => {
  try {
    console.log("RegisterPromoter contract : ",contract)
    const register = await contract.registerPromoter();
    const result = {
      status:"success",
      message:register,
    }
    return result;
  } catch (error) {
    console.log("RegisterPromoter Error: ",error);
    const result = {
      status:"error",
      message:error.reason ? error.reason:"Something went wrong",
    }
    return result;
  }
}

//Function to investToken in presale.
//This function triggers the buyTokensEth, buyTokensBnb, buyTokenUSDT functions to invest in the presale 
//Bases on the payment method Smart contract function will be triggered.
export const investToken = async (contract,ethContractPayment,bnbContractPayment,address, investedamount, paymentMode, referrer, promoter) => {
  if (paymentMode === "BNB") {
    try {
      let weiAmount = parseEther(investedamount.toFixed(18).toString());
      const buy = await bnbContractPayment.buyTokensBNB(
          referrer,  // First argument: referrer address
          promoter,  // Second argument: promoter address
          { value: weiAmount }
      );

      // Fetch updated balance and commission for the user
      await fetchBalance(contract, address);
      await fetchCommision(contract, address);

      // Return the result of the purchase
      return buy;
    } catch (error) {
      // Handle any errors that occur during the process
      console.log("Error", error);
      return (error.reason ? error.reason : error); // Return the error message if available
    }

  } else if (paymentMode === "ETH") {
    try {
      let weiAmount = parseEther(investedamount.toFixed(18).toString())
      const buy = await ethContractPayment.makePayment(
          referrer,  // First argument: referrer address
          promoter,  // Second argument: promoter address
          {value: weiAmount.toString()}  // Send ETH as a value
      );

      // Fetch balances and commissions after the transaction
      await fetchBalance(contract, address);
      await fetchCommision(contract, address);

      return buy;
    } catch (error) {
      console.log("Error", error);
      return (error.reason ? error.reason : error);
    }
  }
  else{
    alert("Payment mode is not specified !")
  }
};

//This function fetches the Custom presale token balance for specific user (web3address)
export async function fetchBalance (contract,address) {
  try {
    const balance = await contract.balances(address);
    const tokens = formatEther(balance.toString());
    localStorage.setItem("HOMETOKENS" , tokens.toString());
    return tokens;
  } catch (error) {
    console.log(error)
  }
}

//This function fetches the Custom presale reward collected by each affilate (web3address)
export async function fetchCommision (contract,address) {
  try {
    const balance = await contract.totalReferenceCommision(address);
    const tokens = formatEther(balance.toString());
    localStorage.setItem("RefCommission" , tokens.toString());
    return tokens;
  } catch (error) {
    console.log(error)
  }
}

//Web3 Function to get the users's affiliate level (1 or 2)
export async function referLayer (contract, address) {
    try {
      // Call the mapping getter function
      const referLayerValue = await contract.referLayer(address);
      console.log("Refer Layer ",referLayerValue);
      return referLayerValue;
    } catch (error) {
      console.error("Error calling referLayer:", error);
    }
}

//Web3Function to withdraw the tokens based on the user's balance
export const handleWithdraw = async (contract) => {
  if(contract != null ){
    try {
      const response = await contract.withdrawUserToken()
      return "Success";
    } catch (error) {
      console.log("HandleWithdraw Error",error)
      return error.reason;
    }
  }
}

//Web3 function to get the current active phase running in the pre sale smart contract
export const currentPhasePrice = async (contract) => {
  if(contract != null ){
    try {
      const currentPrice = await contract.getCurrentPrice();
      const currentPhase = await contract.getCurrentPhase();
      return [currentPhase,currentPrice];
    } catch (error) {
      console.log("HandleWithdraw Error",error)
      alert(error)
    }
  }
}

async function getSigner() {
  // Check if MetaMask is installed
  if (window.ethereum) {
    try {
      // Request account access from the user (prompts MetaMask to pop up)
      await window.ethereum.request({ method: "eth_requestAccounts" });

      // Create a provider using the window.ethereum injected by MetaMask
      const provider = new BrowserProvider(window.ethereum); // ethers v6

      // Get the signer (the connected account)
      const signer = await provider.getSigner(); // ethers v6: await is needed now

      // Now you can use the signer to interact with contracts
      console.log("Signer address:", await signer.getAddress());
      return signer;
    } catch (error) {
      console.error("Error getting signer:", error);
      return null;
    }
  } else {
    console.log("MetaMask not found");
    return null;
  }
}

export async function getUSDConversionRate(contract){
  try{
    return await contract.getUSDConversionRate();
  }
  catch(error){
    console.log(error)
  }
}

export async function getTotalPhasesCount(contract){
  try{
    const totalCount = await contract.getTotalPhasesCount() ; 
    return totalCount;
  }
  catch(error){
    console.log(error)
  }
}

export async function getTotalToken(contract){
  try{
    return await contract.getTotalToken();
  }
  catch(error){
    console.log(error)
  }
}
export async function getPhaseInformation(contract){
  try{
    return await contract.getPhaseInformation();
  }
  catch(error){
    console.log(error)
  }
}



export async function getCurrentPhase(contract){
  try{
    return await contract.getCurrentPhase();
  }
  catch(error){
    console.log(error)
  }
}
